import React, { useState } from 'react';
import './ContactSection.css';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    subject: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('Submitting...');

    // UPDATED: This is your new, live script URL
    const scriptURL = 'https://script.google.com/macros/s/AKfycbxLMTmdCaHPNGBK177YhtjXoE3Ez2hi_Ka3I0fLrKhUAkFvYC-iL0TdtYsEKeGcl64h/exec';
    
    const form = new FormData();
    form.append('name', formData.name);
    form.append('email', formData.email);
    form.append('mobile', formData.mobile);
    form.append('subject', formData.subject);
    form.append('message', formData.message);

    fetch(scriptURL, { method: 'POST', body: form })
      .then(response => {
        setStatus('Message sent successfully!');
        setFormData({ name: '', email: '', mobile: '', subject: '', message: '' }); // Clear form
        console.log('Success!', response);
      })
      .catch(error => {
        setStatus('An error occurred. Please try again.');
        console.error('Error!', error.message);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="contact-section">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
               <div className="info-block">
                <h3 className="info-title">ADDRESS</h3>
                <div className="address-group">
                  <h4>INDIA</h4>
                  <p>Plot No: 6/2 & 6/3, 3rd floor, Techno Pearl building,<br />Huda Techno Enclave,<br />Hi-Tech city, Hyderabad,<br />Telangana- 500081</p>
                </div>
                <div className="address-group">
                  <h4>US</h4>
                  <p># 1016 , Sundrop Dr , Little Elm, TX, USA - 75068</p>
                </div>
              </div>
              <div className="info-block">
                <h3 className="info-title">PHONE</h3>
                <p><a href="tel:+919111234447">+91 9111234447</a></p>
              </div>
              <div className="info-block">
                <h3 className="info-title">EMAIL</h3>
                <p><a href="mailto:info@neuroverseai.com">info@neuroverseai.com</a></p>
              </div>
            </div>

            <div className="contact-form-container">
              <h3 className="form-title">Reach out to us – we're just a message away!</h3>
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Enter your full name" required />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Your Email</label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="Enter your business email" required />
                </div>
                <div className="form-group">
                  <label htmlFor="mobile">Your Contact Number</label>
                  <input type="tel" id="mobile" name="mobile" value={formData.mobile} onChange={handleChange} placeholder="Enter your phone number" required />
                </div>
                <div className="form-group">
                  <label htmlFor="subject">Subject</label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} placeholder="What is this regarding?" required />
                </div>
                <div className="form-group">
                  <label htmlFor="message">How can we help?</label>
                  <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Tell us about your project or needs..." required></textarea>
                </div>
                <button type="submit" className="submit-button" disabled={isSubmitting}>
                  {isSubmitting ? 'Submitting...' : 'Get a Free Consultation'}
                </button>
                {status && <p className="form-status">{status}</p>}
              </form>
            </div>
          </div>
        </div>
      </section>
      <div className="map-section">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.269420606476!2d78.37631537615623!3d17.446814283450493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb91003d8521b%3A0x4652691a6ade2ef0!2sNeuroverseAI%20-%20SAP%20Consulting%20Services%20Company%20in%20USA%2C%20UAE%2C%20India!5e0!3m2!1sen!2sus!4v1753474728500!5m2!1sen!2sus" 
          width="100%" 
          height="450" 
          style={{ border:0 }} 
          allowFullScreen="" 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade"
          title="NeuroverseAI Office Location"
        ></iframe>
      </div>
    </>
  );
};

export default ContactSection;
